import React, { useEffect, useState } from "react";
import { Images } from "../../assets/common";
import axios from "axios";
import { SERVER_URL } from "./../../constants/api";
import cookieStorage from "./../../services/cookie-storage";
import { useHistory } from "react-router-dom";
import Loader from "./../../components/Loader";
import { screenWidth } from "../../constants/function";

export default function ServerDown() {
  const width = window.innerWidth;
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  var goToHome = true;

  const checkServerStatus = async () => {
    try {
      setLoading(true);
      const response = await axios
        .get(`${SERVER_URL}/user/balance/v2`, {
          headers: {
            Authorization: cookieStorage.getCookie("Authorization"),
          },
        })
        .catch(async (error) => {
          if (
            error.response.data["message"] ===
              "App is temporarily unavailable" ||
            error.response.data["code"] === "SERVER_DOWN"
          ) {
            // console.log("Server down");
            goToHome = false;
          }
        })
        .then((response) => {
          // console.log("error respones",goToHome, response);
          if (goToHome) {
            history.push("/app/Home");
          }
        });
      setLoading(false);
    } catch (error) {
      //console.log(error);
      setLoading(false);
    }
  };
  useEffect(() => {
    checkServerStatus();
  }, []);



  return (
    <div>
      <img
        style={{ height: "100vh", width: "100%" }}
        src={screenWidth() > 600 ? Images.returnInApril : Images.returnInApril_mbl }
        alt="App is temporarily unavailable"
      />
      {loading ? <Loader /> : null}
    </div>
  );
}
